export function slugifyCompanyName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // remove special characters
    .replace(/[\s_-]+/g, '-') // replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ''); // remove leading or trailing hyphens
}

export function getEmployerProfileUrl(
  employerId: number,
  companyName: string,
  localePath: Function,
): string {
  const slug = slugifyCompanyName(companyName);
  return localePath({
    name: 'employers-employerId-slug',
    params: { employerId, slug },
  });
}

export function useEmployerUrl() {
  const localePath = useLocalePath();

  return {
    slugifyCompanyName,
    getEmployerProfileUrl: (employerId: number, companyName: string) =>
      getEmployerProfileUrl(employerId, companyName, localePath),
  };
}
